export default {
    // General
    loading: 'Yükleniyor',
    home: 'Ana Sayfa',
    back: 'Geri',
    confirm: 'Onayla',
    cancel: 'İptal',
    close: 'Kapat',
    save: 'Kaydet',
    delete: 'Sil',
    edit: 'Düzenle',
    add: 'Ekle',
    yes: 'Evet',
    no: 'Hayır',
    or: 'veya',
    and: 've',
    required: 'Zorunlu',
    optional: 'İsteğe bağlı',

    // Store status
    storeOpen: 'Açık',
    storeClosed: 'Kapalı',
    storeOpenSoon: 'Yakında açılıyor',

    // Navigation
    categories: 'Kategoriler',
    siteMap: 'Site Haritası',
    cart: 'Sepet',
    myAccount: 'Hesabım',

    // Auth
    login: 'Giriş Yap',
    register: 'Kayıt Ol',
    logout: 'Çıkış Yap',
    forgotPassword: 'Şifremi unuttum',
    rememberMe: 'Beni hatırla',
    alreadyHaveAccount: 'Zaten hesabınız var mı?',
    noAccount: 'Hesabınız yok mu?',
    signIn: 'Giriş yap',

    // Form fields
    email: 'E-posta',
    password: 'Şifre',
    confirmPassword: 'Şifre tekrar',
    firstName: 'Ad',
    lastName: 'Soyad',
    phone: 'Telefon',
    address: 'Adres',
    city: 'Şehir',
    postalCode: 'Posta kodu',
    country: 'Ülke',

    // Password rules
    passwordRules: 'Şifre en az 10 karakter, bir büyük harf, bir küçük harf, bir rakam ve bir özel karakter içermelidir',
    confirmPasswordMessage: 'Lütfen şifrenizi onaylayın',
    passwordValid: 'Şifre geçerli',
    passwordInvalid: 'Şifre geçersiz',
    passwordMismatch: 'Şifreler eşleşmiyor',
    passwordMissingLength: 'en az {min} karakter',
    passwordMissingUppercase: 'bir büyük harf',
    passwordMissingLowercase: 'bir küçük harf',
    passwordMissingNumber: 'bir rakam',
    passwordMissingSpecial: 'bir özel karakter',
    optionFreeRemaining: '{count} ücretsiz seçenek daha seçebilirsiniz!',
    optionSelectAtLeastOne: 'En az bir seçenek seçmelisiniz!',
    optionSelectionRequired: 'Bu seçenek için bir seçim gereklidir!',
    mustAcceptTerms: 'Kullanım koşullarını kabul etmelisiniz.',
    registerFormAlreadySubmitted: 'Kayıt formu gönderildi, lütfen bekleyin!',
    newPassword: 'Yeni şifre',
    oldPassword: 'Eski şifre',
    verifyingInfo: 'Bilgileriniz doğrulanıyor',
    contactUs: 'Lütfen bizimle iletişime geçin!',
    invalidInfo: 'Bilgileriniz geçersiz',
    deleteAccountRequest: 'Hesap silme talebi',
    deleteAccountConfirmText: 'Hesabınızı silmek istiyorsanız şifrenizi girin',

    // Terms
    acceptTerms: 'Kullanım koşullarını kabul ediyorum',
    privacyPolicy: 'Gizlilik Politikası',
    termsOfUse: 'Kullanım Koşulları',

    // Product
    select: 'Seç',
    addToCart: 'Ekle',
    options: 'Seçenekler',
    description: 'Açıklama',
    noDescription: 'Açıklama mevcut değil',
    nameUnavailable: 'İsim mevcut değil',
    someOptionsPaid: 'bazı seçenekler ücretlidir',

    // Cart / Order
    cartTitle: 'Sepet',
    cartSummary: 'Sepet Özeti',
    orderCommand: 'Sipariş Ver',
    validateOrder: 'Siparişi Onayla',
    total: 'Toplam',
    subtotal: 'Ara Toplam',
    deliveryFees: 'Teslimat Ücreti',
    free: 'ücretsiz',
    paid: 'ücretli',
    orderPaid: 'Ödendi',
    orderUnpaid: 'Ödenmedi',
    maximum: 'maksimum',
    quantity: 'Adet',

    // Payment
    payByCard: 'Kartla Öde',
    payOnSite: 'Yerinde Öde',
    paymentSuccess: 'Ödeme Başarılı',
    paymentError: 'Ödeme Hatası',

    // Delivery
    delivery: 'Teslimat',
    pickup: 'Gel Al',
    tableReservation: 'Masa Rezervasyonu',
    deliveryZones: 'Teslimat Bölgeleri',
    deliveryFee: 'Teslimat ücreti',
    minimumOrder: 'Minimum sipariş',
    freeFrom: 'Ücretsiz teslimat',

    // Dashboard
    dashboard: 'Kontrol Paneli',
    orderHistory: 'Sipariş Geçmişi',
    addressBook: 'Adres Defteri',
    setDefault: 'Varsayılan',
    requestAccessCode: 'Hesabınıza erişmek için kod isteyin',
    code: 'Kod',
    myInfo: 'Bilgilerim',
    myAddresses: 'Adreslerim',
    addAddress: 'Adres Ekle',
    editAddress: 'Adres Düzenle',
    deleteAddress: 'Adres Sil',
    deleteAccount: 'Hesabımı Sil',
    modifyPassword: 'Şifre Değiştir',
    cancelAccountDeletion: 'Hesap Silmeyi İptal Et',
    loginToOrder: 'Sipariş vermek için giriş yapmalısınız',
    send: 'Gönder',
    missingFields: 'Eksik veya geçersiz alanlar',
    forgotPasswordDescription: 'Şifrenizi sıfırlamak için e-posta adresinizi girin',
    enterEmail: 'E-posta adresinizi girin',
    forgotPasswordTitle: 'Şifremi unuttum',
    passwordResetTitle: 'Şifre sıfırlama',
    disconnectSuccess: 'Başarıyla çıkış yapıldı',
    captchaRequired: 'Lütfen captcha\'yı tamamlayın',
    captchaLoading: 'Captcha yükleniyor...',
    captchaError: 'Captcha hatası. Lütfen tekrar deneyin.',
    retry: 'Tekrar dene',
    productAddedSuccess: 'Ürününüz başarıyla eklendi!',
    productAssociatedSuggestion: 'Müşteriler seçiminize eşlik etmesi için bu ürünleri de öneriyor.',
    productAssociatedTitle: 'İlgili ürün(ler)',
    removeProductQuestion: 'Bu ürünü sepetten kaldırmak istiyor musunuz?',
    waitBeforeRetry: 'Tekrar tıklamadan önce lütfen bekleyin',
    fillRequiredFields: 'Lütfen tüm zorunlu alanları doldurun',
    otpInvalid: 'Lütfen geçerli bir OTP kodu girin',
    otpSendError: 'OTP kodu gönderilirken hata oluştu',
    infoUnchanged: 'Bilgiler değişmedi',
    selectAddressToModify: 'Değiştirmek için bir adres seçin',
    orderPlacedSuccess: 'Sipariş başarıyla verildi!',
    paymentSuccessMessage: 'Tebrikler, ödemeniz başarıyla alındı!',
    orderTransmittedRestaurant: 'Siparişiniz restorana iletildi',
    orderNumberLabel: 'Sipariş numarası:',
    pickupOrderMessage: 'Siparişinizi şu saatte alabilirsiniz:',
    wishGoodDayMeal: 'Size iyi günler ve afiyet olsun dileriz',
    wishGoodAfternoonMeal: 'Size iyi öğleden sonralar ve afiyet olsun dileriz',
    wishGoodEveningMeal: 'Size iyi akşamlar ve afiyet olsun dileriz',
    addressNotFound: 'Adres bulunamadı',
    accountDeletionTitle: 'Hesap silme',
    accountDeletionCancelError: 'Hesap silme iptali hatası',
    personalInfoTitle: 'Kişisel bilgiler',
    selectAddressTitle: 'Bir adres seçin',
    selectedAddressNotFound: 'Seçilen adres bulunamadı',
    todayOrders: "Bugünkü Siparişler",
    previousOrders: 'Eski Siparişler',
    order: 'Sipariş',
    pickupTime: 'Teslim Alma Saati',
    notConfirmed: 'Onaylanmadı',
    cancelled: 'İptal Edildi',
    company: 'Şirket',
    addressComplement: 'Adres Tamamlayıcı (Bina / Daire / Kat)',
    region: 'Bölge',
    selectRegion: 'Bölge seçin',
    selectCity: 'Şehir seçin',
    address1: 'Adres 1',
    // refactored — address form'a özel key'ler (TR semantiği: Mahalle → Cadde hiyerarşisi;
    // admin mahalle ve bağlı caddeleri DB'den yönetir).
    addressFormZoneLabel: 'Mahalle',
    addressFormCityLabel: 'Cadde',
    addressFormStreetLabel: 'Adres',
    addressFormSelectZone: 'Mahalle seçin',
    addressFormSelectCity: 'Cadde seçin',
    addressSearchPlaceholder: 'Adres ara (sokak, cadde, bina…)',
    addressMapHint: 'Haritaya tıklayın veya marker’ı sürükleyerek tam konumu seçin.',
    addressMapPicked: 'Seçilen konum',
    defaultAddressQuestion: 'Varsayılan adres',
    mandatory: 'Zorunlu',
    noOrdersYet: 'Henüz siparişiniz yok',
    noAddressesYet: 'Henüz kayıtlı adresiniz yok',
    cartEmpty: 'Sepet boş',
    storeClosedLong: 'İşletme kapalı',

    // Order validation page
    fullName: 'Ad ve soyad',
    orderOptions: 'Sipariş seçenekleri',
    pickupMethod: 'Teslim alma yöntemi',
    withdrawTitle: 'Teslim alma',
    paymentMethod: 'Ödeme yöntemi',
    asSoonAsPossible: 'En kısa sürede',
    todayLabel: 'Bugün',
    existingAddress: 'Mevcut adres',
    newAddress: 'Yeni adres',
    addressAddedSuccess: 'Yeni adresiniz başarıyla eklendi.',
    selectDeliveryAddress: 'Lütfen bir teslimat adresi seçiniz.',
    priceDoesntMeetDelivery: 'Fiyat, teslimat koşullarını karşılamıyor',
    restaurantDoesntAcceptPickupDelivery: 'Restoran teslim alma veya teslimat kabul etmiyor',
    storeCannotTakeOrderNow: 'Restoran şu anda siparişinizi alamıyor. Lütfen daha sonra tekrar deneyin',
    cardMinimumAmount: 'Kart ile sipariş vermek için toplam tutar {amount} veya daha fazla olmalıdır.',
    hourLabel: 'Saat',
    minuteLabel: 'Dakika',
    addressPlaceholder: 'Adres',
    emptyBasketProducts: 'Sepette ürün yok',
    taxIncluded: 'KDV ({rate}%) Dahil',
    shippingTaxIncluded: "Teslimat ücreti KDV'si ({rate}%) Dahil",
    withShippingFees: 'teslimat ücreti dahil',
    addCommentPlaceholder: 'Bir yorum ekleyebilirsiniz',
    demoCannotOrder: 'Bu site bir demodur, sipariş veremezsiniz',
    demoCannotPassOrder: 'Sipariş veremezsiniz, bu site bir demodur',
    validateInformationButton: 'Bilgileri onayla',
    termsValidationIntro: 'Bu siparişi onaylayarak şunları okuduğunuzu ve kabul ettiğinizi onaylıyorsunuz:',
    termsValidationMiddle: 've',
    termsValidationEnd: 'Satın almayı tamamlamadan önce bunları dikkatlice okumanızı öneririz',

    // Store status banner
    storeOpensAt: 'Saat {time} itibarıyla açılıyor',
    storeClosedOpensOn: 'Kapalı, {day} günü saat {time} itibarıyla açılıyor',
    storeOrderOpenOpensAt: 'Sipariş sistemi aktif, siparişinizi şimdi geçebilir ve saat {time}\'dan itibaren teslim alabilirsiniz.',
    storeOpenOrderClosed: 'İşletme Açık - Sipariş Kapalı',
    dayFullSunday: 'Pazar',
    dayFullMonday: 'Pazartesi',
    dayFullTuesday: 'Salı',
    dayFullWednesday: 'Çarşamba',
    dayFullThursday: 'Perşembe',
    dayFullFriday: 'Cuma',
    dayFullSaturday: 'Cumartesi',

    // Order status
    orderPending: 'Beklemede',
    orderPreparation: 'Hazırlanıyor',
    orderReady: 'Hazır',
    orderDelivered: 'Teslim Edildi',
    orderCancelled: 'İptal Edildi',

    // Footer
    openingHours: 'Çalışma Saatleri',
    pickupService: 'Alım Saatleri',
    deliveryService: 'Teslimat Saatleri',
    allRightsReserved: 'Tüm hakları saklıdır',
    dayShortMon: 'Pzt',
    dayShortTue: 'Sal',
    dayShortWed: 'Çar',
    dayShortThu: 'Per',
    dayShortFri: 'Cum',
    dayShortSat: 'Cmt',
    dayShortSun: 'Paz',

    // Errors
    error: 'Hata',
    attention: 'Dikkat',
    networkError: 'Ağ hatası',
    unauthorized: 'Yetkisiz erişim',

    // Validation errors (backend keys)
    phone_missing: 'Telefon numarası eksik',
    phone_invalid: 'Telefon numarası geçerli değil',
    lastname_missing: 'Soyad eksik',
    lastname_invalid: 'Soyad geçerli değil',
    firstname_missing: 'Ad eksik',
    firstname_invalid: 'Ad geçerli değil',
    password_missing: 'Şifre eksik',
    password_rules_violated: 'Şifre kurallara uymuyor',
    password_confirm_missing: 'Şifre onayı eksik',
    password_confirm_rules_violated: 'Şifre onayı kurallara uymuyor',
    password_mismatch: 'Şifreler eşleşmiyor',
    store_name_missing: 'Mağaza adı eksik',
    store_name_invalid: 'Mağaza adı geçerli değil',
    language_missing: 'Dil eksik',
    language_invalid: 'Dil geçerli değil',
    customer_missing: 'Müşteri bilgisi eksik',
    customer_invalid: 'Müşteri bilgisi geçerli değil',
    store_missing: 'Mağaza bilgisi eksik',
    store_invalid: 'Mağaza bilgisi geçerli değil',
    remember_me_invalid: '"Beni hatırla" seçeneği geçerli değil',
    email_missing: 'E-posta adresi eksik',
    email_invalid: 'E-posta adresi geçerli değil',
    email_domain_invalid: 'E-posta alan adı geçerli değil',
    address_fields_missing: 'Adres alanları eksik',
    zone_missing: 'Bölge bilgisi eksik',
    city_missing: 'Şehir eksik',
    city_invalid: 'Şehir geçerli değil',
    city_too_short: 'Şehir adı çok kısa',
    city_too_long: 'Şehir adı çok uzun',
    supaddress_missing: 'Ek adres bilgisi eksik',
    supaddress_too_short: 'Ek adres çok kısa',
    supaddress_too_long: 'Ek adres çok uzun',
    supaddress_invalid: 'Ek adres geçerli değil',
    address_missing: 'Adres eksik',
    address_too_short: 'Adres çok kısa',
    address_too_long: 'Adres çok uzun',
    address_invalid: 'Adres geçerli değil',
    company_name_too_short: 'Şirket adı çok kısa',
    company_name_too_long: 'Şirket adı çok uzun',
    company_name_invalid: 'Şirket adı geçerli değil',
    address_id_missing: 'Adres ID eksik',
    address_id_invalid: 'Adres ID geçerli değil',

    // Backend messages (snake_case keys)
    invalid_data: 'Veriler geçerli değil',
    terms_not_accepted: 'Kullanım koşullarını kabul etmelisiniz',
    generic_error: 'Bir hata oluştu! Sorun devam ederse işletmeyle iletişime geçin.',
    session_expired: 'Oturumunuzun süresi doldu. Lütfen tekrar giriş yapın.',
    token_invalid_or_expired: 'Token geçersiz veya süresi dolmuş',
    refresh_token_missing: 'Yenileme tokeni eksik',
    refresh_token_invalid: 'Yenileme tokeni geçersiz veya süresi dolmuş',
    token_refresh_success: 'Token başarıyla yenilendi',
    captcha_failed: 'Captcha doğrulaması başarısız oldu',
    email_already_used: 'Bu e-posta adresi zaten kullanılıyor',
    register_error_generic: 'Kayıt sırasında bir hata oluştu',
    register_error_retry: 'Kayıt sırasında bir hata oluştu, lütfen tekrar deneyin',
    register_success_verify_email: 'Kayıt başarılı. Lütfen e-postanızı doğrulayın',
    confirm_register_error: 'Kayıt onaylama hatası',
    store_id_invalid: 'Mağaza kimliği geçerli değil',
    store_id_mismatch: 'Mağaza kimliği eşleşmiyor',
    store_not_found: 'Mağaza bulunamadı',
    store_setting_not_found: 'Ayar bulunamadı',
    store_privacy_policy_not_found: 'Gizlilik politikası bulunamadı',
    store_condition_use_not_found: 'Kullanım koşulları bulunamadı',
    store_theme_not_found: 'Tema bulunamadı',
    store_no_categories: 'Bu mağazaya bağlı kategori yok',
    store_no_category_ids: 'Bu kimliklerle kategori bulunamadı',
    store_load_error: 'Mağaza verilerini yüklerken bir hata oluştu',
    user_not_found: 'Kullanıcı bulunamadı',
    customer_id_invalid: 'Kullanıcı kimliği geçerli değil',
    customer_id_missing: 'Kullanıcı kimliği eksik',
    customer_fetch_error: 'Kullanıcı bilgilerini alırken bir hata oluştu',
    customer_error_generic: 'Kullanıcı hatası',
    customer_data_missing: 'Müşteri verileri eksik',
    customer_data_invalid: 'Müşteri verileri hatalı',
    email_not_verified: 'Kullanıcı e-posta adresini doğrulamadı',
    email_not_verified_cannot_modify_password: 'Değişiklik yapmadan önce e-posta adresinizi doğrulayın',
    email_or_password_invalid: 'E-posta veya şifre geçerli değil',
    email_or_store_invalid: 'E-posta veya mağaza geçersiz',
    email_already_confirmed: 'E-posta adresiniz zaten doğrulandı',
    email_confirmed_success: 'E-posta adresiniz doğrulandı, yönlendiriliyorsunuz',
    password_incorrect: 'Şifre doğru değil',
    password_invalid: 'Şifre geçersiz',
    old_password_invalid: 'Eski şifre geçerli değil',
    password_reset_link_active: 'Aktif bir şifre sıfırlama bağlantısı mevcut',
    reset_link_already_active: 'Zaten aktif bir sıfırlama bağlantısı var. Lütfen e-postanızı kontrol edin',
    reset_token_expired: 'Değişikliğin süresi doldu, lütfen yeni bir talep oluşturun',
    reset_token_expired_retry: 'Token geçersiz veya süresi doldu, yeni bir talep oluşturun',
    forget_password_email_sent: 'Şifrenizi değiştirmek için bir e-posta alacaksınız',
    forget_password_error: 'Şifremi unuttum talebinde bir hata oluştu',
    password_reset_success: 'Şifreniz başarıyla değiştirildi!',
    password_reset_error: 'Unutulan şifreyi güncellerken bir hata oluştu',
    user_cannot_change_password: 'Kullanıcı şifresini değiştiremez!',
    user_cannot_modify_password: 'Kullanıcı şifresini değiştiremez',
    verify_modify_success: 'Kullanıcı şifresini değiştirebilir',
    update_success: 'Bilgiler başarıyla güncellendi',
    update_error: 'Veriler güncellenirken bir hata oluştu!',
    update_password_success: 'Şifre başarıyla güncellendi',
    update_password_success_redirect: 'Şifreniz başarıyla değiştirildi, yönlendiriliyorsunuz',
    update_password_error: 'Şifre güncellenirken bir hata oluştu',
    user_pending_deletion: 'Kullanıcı hesap silme talebinde bulundu',
    account_pending_deletion_service_denied: 'Hesabınız silme talebinde bulundu',
    user_no_deletion_request: 'Kullanıcı hesap silme talebinde bulunmadı',
    user_archived: 'Kullanıcı arşivlendi',
    user_deleted_success: 'Hesabınız başarıyla silindi',
    delete_user_error: 'Hesabınızı silerken bir hata oluştu',
    delete_request_success: 'Hesap silme talebiniz kaydedildi',
    delete_request_error: 'Hesap silme talebinde bir hata oluştu',
    cancel_delete_success: 'Hesap silme talebiniz başarıyla iptal edildi',
    cancel_delete_success_with_warning: 'Hesap silme talebiniz başarıyla iptal edildi. Güvenliğiniz için şifrenizi güncellemeniz önerilir.',
    account_verification_error: 'Hesap doğrulaması sırasında bir hata oluştu',
    login_success: 'Giriş başarılı, yönlendiriliyorsunuz',
    login_success_old_password: 'Giriş başarılı, yönlendiriliyorsunuz. Güvenliğiniz için şifrenizi güncelleyin',
    login_error_generic: 'Giriş sırasında bir hata oluştu',
    disconnect_success: 'Başarıyla çıkış yapıldı',
    disconnect_error: 'Çıkış sırasında bir hata oluştu',
    me_success: 'Bilgiler başarıyla alındı',
    fetch_me_error: 'Bilgilerinizi alırken bir hata oluştu',
    otp_request_success: 'Kod talebi geçerli',
    otp_request_error: 'Kod talebi sırasında bir hata oluştu',
    otp_valid: 'Kod geçerli, bilgilerinizi değiştirebilirsiniz',
    otp_invalid: 'Kod geçersiz, kodunuzu kontrol edin',
    otp_already_used: 'Giriş kodunuzu zaten kullandınız',
    otp_verification_error: 'Kod doğrulaması sırasında bir hata oluştu',
    otp_verification_success: 'Giriş kodu başarıyla doğrulandı',
    otp_send_success: 'Giriş kodu e-posta ile gönderildi',
    otp_send_error: 'Giriş kodunu gönderirken bir hata oluştu',
    city_or_postal_invalid: 'Şehir veya posta kodu geçerli değil',
    address_duplicate: 'Bu şehir için aynı adres zaten mevcut',
    address_not_found: 'Bu adres mevcut değil',
    address_not_found_for_customer: 'Bu müşteri için adres bulunamadı',
    address_id_missing_or_invalid: 'Adres kimliği eksik veya geçersiz',
    address_limit_reached: 'İzin verilen maksimum adres sayısına ulaştınız',
    address_added_success: 'Adresiniz başarıyla kaydedildi',
    address_added_success_default: 'Adresiniz varsayılan olarak kaydedildi',
    address_added_error: 'Adres eklenirken bir hata oluştu',
    address_update_success: 'Adresiniz başarıyla güncellendi',
    address_update_success_default: 'Adresiniz varsayılan olarak güncellendi',
    address_update_error: 'Adres güncellenirken bir hata oluştu',
    address_delete_success: 'Adres silindi',
    address_delete_error: 'Adres silinirken bir hata oluştu',
    address_fetch_error: 'Adres verileri alınırken bir hata oluştu',
    order_too_many_requests: 'Çok fazla istek. Tekrar denemeden önce lütfen bekleyin.',
    order_price_mismatch: 'Gönderilen fiyat verilerle uyuşmuyor',
    order_created_success: 'Sipariş oluşturuldu',
    order_creation_error: 'Sipariş oluşturulurken bir hata oluştu',
    order_cancelled_success: 'Sipariş değiştirildi',
    order_cancel_error: 'Hata',
    order_id_missing: 'Sipariş kimliği eksik',
    order_id_invalid: 'Sipariş kimliği geçerli değil',
    orders_not_found: 'Sipariş bulunamadı',
    orders_fetch_success: 'Siparişler başarıyla alındı',
    order_stripe_failed: 'Ödeme oturumu oluşturulamadı. Lütfen restoranla iletişime geçin.',
    pay: 'Öde',
    amountUnavailable: 'Tutar mevcut değil',

    // Legal pages (CGU / Privacy Policy)
    cguTitle: 'Kullanım koşulları',
    privacyTitle: 'Gizlilik politikası',
    lastUpdated: 'Son güncelleme :',
    cguIntro: 'İşbu kullanım koşulları, https://{hostname} sitesinin ve hizmetlerinin kullanımını düzenler. Bu siteye erişerek ve kullanarak, bu koşullarla bağlı olmayı kabul etmiş olursunuz. Bu koşulları kabul etmiyorsanız, lütfen sitemizi kullanmayın.',
    privacyWelcomeBefore: 'Hoş geldiniz ',
    privacyWelcomeAfter: ', çevrimiçi sipariş hizmeti sunuyoruz.',
    privacyIntro: 'İşbu gizlilik politikası, kişisel verilerinizi nasıl topladığımızı, kullandığımızı ve koruduğumuzu açıklar.',
    contactLabel: 'İletişim :',

    // Page titles (browser tab)
    productCatalog: 'Ürün Kataloğu',
    productDetails: 'Ürün',
    registerTitle: 'Kayıt Ol',
    confirmRegistration: 'Kayıt Onayı',
    cartOrderTitle: 'Sepet - Sipariş',
    dashboardEditInfo: 'Kontrol Paneli - Kişisel Bilgileri Düzenle',
    dashboardEditPassword: 'Kontrol Paneli - Şifre Değiştir',
    dashboardAddresses: 'Kontrol Paneli - Adres Yönetimi',
    dashboardOrders: 'Kontrol Paneli - Sipariş Geçmişi',

    // Language names
    languages: {
        tr: 'Türkçe',
        fr: 'Français',
        en: 'English',
        de: 'Deutsch'
    }
}
